module.exports = __webpack_public_path__ + "static/media/paddle.8436dd97.svg";